import { useRouter } from "@src/lib/router";
import React from "react";

const FolderHome = () => {
  // NEXTJS ROUTER
  const router = useRouter();

  return <h1>CourseId:{router.query.courseId}</h1>;
};


export default FolderHome;
